import React from "react";
import { Flex, Text } from "@chakra-ui/react";

/**
 * EmptyState — centered icon tile + heading + hint, for empty tables/panels.
 * Template ref: `.empty` + `.emptyIcon`.
 *
 * Props:
 *   icon  - node rendered inside the rounded icon tile (omit to hide the tile)
 *   title - bold heading text/node
 *   hint  - secondary explanatory line
 */
const EmptyState = ({ icon, title, hint, ...rest }) => (
  <Flex
    direction="column"
    align="center"
    justify="center"
    textAlign="center"
    minH="188px"
    gap="8px"
    p="20px"
    color="#778b99"
    {...rest}
  >
    {icon && (
      <Flex
        align="center"
        justify="center"
        boxSize="46px"
        borderRadius="16px"
        bg="#EEF5F7"
        borderWidth="1px"
        borderColor="#D4E2E8"
        color="portal.primary"
        fontSize="20px"
      >
        {icon}
      </Flex>
    )}
    {title && (
      <Text fontWeight="800" color="portal.text" sx={{ marginBottom: "0 !important" }}>
        {title}
      </Text>
    )}
    {hint && (
      <Text fontSize="12px" maxW="340px" sx={{ marginBottom: "0 !important" }}>
        {hint}
      </Text>
    )}
  </Flex>
);

export default EmptyState;
